export enum ComponentTypeReportingDefaults {
DTVMARQUEE = "dtvMarquee",
DTVCAROUSEL = "dtvCarousel",
CHANNEL_COMPARISON_TOOL = "CHANNEL_COMPARISON_TOOL",
FAQ = "faqPanel",
FAQV2 = "faqPanel",
FORM_BUILDERV2 = "formBuilder",
BREADCRUMBSV2 = "breadCrumbs",
QUIZV2 = "quizComponent",
EMAILPOPUPMODAL = "emailPopupModal",
ROWCANVASV2 = "rowCanvas",
FLOATINGWIDGETV2 = "floatingWidget",
// W&C MUI5 Comps
LONGFORMATCARD = "dtvLongFormatCard",
CONTENTCARDS = "contentCard",
PAGESECTIONHEADER = "dtvPageSectionHeader",
PLANCARD = "dtvPlanCard",
INPAGELEGAL = "dtvInPageLegal",
INTERNALPRODCUTCOMPARISIONCHART = "internalProductComparisionChart",
DTVHERO = "dtvHero",
VERTICALSPACER = "dtvVerticalSpacer",
HEADLINE = "dtvHeadline",
LIST_ITEM = "dtvListItem",
FOUR_UP_ICON_LIST = "dtv4UpIconListItem",
MESSAGINGBANNER = "dtvMessagingBanner",
MESSAGINGCARD = "dtvMessagingCard",
EXTERNALSERVICECOMPARISON = "dtvExternalServiceComparison",
EXTERNALSERVICECOMPARISONTABS = "dtvExternalServiceComparisonChartTabs",
DTV1UP2UPMEDIA = "dtv1Up2UpMedia",
DTVIFRAME = "iframe",
DTVLINKFARM = "dtvLinkFarm",
AGNOSTICPLANCARDS = "dtvAgnosticPlanCards",
INSIDERARTICLE = "insiderPanel",
FINDRETAILER = "findRetailer",
CHANNELLOGOCAROUSAL = "channelLogoCarousal",
DTVFIRSTNAME = "dtvFirstName",
DTVTHREEUP = "dtvThreeUp",
LINKFOREST = "dtvLinkFarm",
PACKAGECOMPARISONCALCULATOR = "PACKAGECOMPARISONCALCULATOR",
LOCALCHANNELSLOOKUPPAGE = "LOCALCHANNELSLOOKUPPAGE",
DTVFLASH="dtvFlash",
DTVCOUNTDOWN="dtvCountDown",
EXITMODAL="exitModal",
VIDEOMARQUEECAMPAIGN="videoMarqueeCampaign",
RSNLOOKUPTOOL="RsnLookupTool",
SITEMAP = "siteMap",
}